import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { ReleaseNotesService } from 'release-notes/release-notes.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'providers/environment.service';

@Component({
    selector: 'ce-release-info',
    templateUrl: './release-info.component.html',
    styleUrls: ['./release-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class ReleaseInfoComponent implements OnInit {
    @Input() @HostBinding('class') public themeClass: 'theme-mykempower' | 'theme-chargeye' = 'theme-chargeye';

    constructor(
        private router: Router,
        private releaseNotesService: ReleaseNotesService,
        private cdRef: ChangeDetectorRef,
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {
        this.environmentService
            .getAppOrigin$()
            .pipe(untilDestroyed(this))
            .subscribe((origin) => {
                this.themeClass = `theme-${origin}`;
                this.cdRef.markForCheck();
            });
    }

    displayNotification = false;
    // Local storage key to store seen versions of release notes
    private readonly STORAGE_KEY = 'release_notes_viewed';

    ngOnInit(): void {
        // Subscribe to the notification observable to toggle the notification dot
        this.releaseNotesService.notification$.pipe(untilDestroyed(this)).subscribe((val) => {
            this.displayNotification = val;
            this.cdRef.markForCheck();
        });
    }

    async onClick() {
        const releaseType = this.themeClass === 'theme-mykempower' ? 'firmware' : 'chargeye';

        // Navigate to the release note page
        this.router.navigate([`release-notes/${releaseType}`]);

        // Update the seen versions of release notes into local storage
        // Let's get CE's main.html file to check for new versions from there
        const mainPageHtml = (await this.releaseNotesService.getMainReleaseNotesHtml(true)) as Document;
        const newVers = Array.from(mainPageHtml.querySelectorAll('h2')).map((a) => a.textContent);
        const seenVers = this.releaseNotesService.getSeenVersionsFromLocal();
        const notSeenVers = newVers.filter((v) => !seenVers.includes(v));
        // Check if seen all the new versions already
        const shouldUpdateSeen = notSeenVers.length > 0;
        if (shouldUpdateSeen) {
            // Update the seen versions to include also the new verions not seen before
            const updatedSeenVers = [...seenVers, ...notSeenVers];
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(updatedSeenVers));
        }

        this.releaseNotesService.updateNotification(false);
        this.cdRef.markForCheck();
    }
}
